import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const LoadingOverlay = () => {
	const overlayStyle = {
		position: "fixed",
		top: 0,
		left: 0,
		width: "100%",
		height: "100%",
		backgroundColor: "rgba(0, 0, 0, 0.5)",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		zIndex: 1300,
	};

	return (
		<div style={overlayStyle}>
			<CircularProgress color="primary" />
		</div>
	);
};

export default LoadingOverlay;
